import React from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { checkIfEmpty } from "../validation/supportForm";

const renderField = ({
  input,
  type,
  placeholder,
  className,
  meta: { error },
}) => {
  const errorToShow = error ? error[0] : null;
  return (
    <div>
      <input
        {...input}
        className={className}
        type={type}
        placeholder={placeholder}
      ></input>
      {errorToShow ? (
        <div className="errorMsg mar-t-3">{errorToShow}</div>
      ) : null}
    </div>
  );
};

const renderTextArea = ({
  input,
  type,
  placeholder,
  className,
  meta: { error },
}) => {
  const errorToShow = error ? error[0] : null;
  return (
    <div>
      <textarea
        {...input}
        className={className}
        rows="15"
        type={type}
        placeholder={placeholder}
      />
      {errorToShow ? <div className="errorMsg">{errorToShow}</div> : null}
    </div>
  );
};

const SupportForm = (props) => {
  const {
    handleSubmit,
    closeSupportModal,
    orderAssistance,
    sendSupportMessage,
  } = props;

  const submit = (fields) => {
    const response = checkIfEmpty(fields);

    if (Object.keys(response).length) {
      throw new SubmissionError(response);
    }

    sendSupportMessage({
      name: orderAssistance.get("name"),
      email: orderAssistance.get("email"),
      orderId: orderAssistance.get("orderId"),
      orderType: orderAssistance.get("orderType"),
      subject: fields.subject,
      message: fields.message,
    });
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      <div className="mar-b-10">
        <Field
          name="subject"
          component={renderField}
          type="text"
          placeholder="Subject"
          className="cc-input"
        />
      </div>
      <div className="mar-b-10">
        <Field
          name="message"
          component={renderTextArea}
          type="text"
          placeholder="Please describe your issue in detail so we can assist you."
          className="cc-input modal-text-area"
        />
      </div>
      <div className="modal-input-mar-b-20">
        <div className="modal-input-flex-2-pad-r-10">
          <button type="submit" className="acct-pg-btn acct-pg-btn-block">
            Submit
          </button>
        </div>
        <div className="modal-input-pad-l-10">
          <div
            className="acct-pg-btn-inverse acct-pg-btn-block"
            onClick={closeSupportModal}
          >
            Close
          </div>
        </div>
      </div>
    </form>
  );
};

export default reduxForm({
  form: "support",
  enableReinitialize: true,
})(SupportForm);
